import React from 'react';
import { FormattedMessage } from 'react-intl';

import { dicomRequirements } from '../../config.json';
import Card from './Card';
import FormCheck from './FormCheck';
import ValidationTooltip from './ValidationTooltip';

const propTypes = {};

class DicomCard extends React.Component {
  state = {};

  attachRef = controlRef => {
    this.setState({ controlRef });
  };

  render() {
    const { onChange, meta, value } = this.props;
    const { controlRef } = this.state;

    return (
      <Card>
        <Card.Body>
          <Card.Heading>
            <FormattedMessage
              defaultMessage="Connect Butterfly Cloud to your PACS/VNA"
              id="checkout.dicom.heading"
            />
          </Card.Heading>
          <p>
            <FormattedMessage
              defaultMessage="Do you want to send studies from Butterfly Cloud to a PACS/VNA, or connect with a Modality worklist?"
              id="checkout.dicom.body"
            />
          </p>
          <FormCheck
            type="radio"
            name="dicomNotify"
            ref={this.attachRef}
            invalid={meta.invalid}
            checked={value === true}
            onChange={() => onChange(true)}
          >
            <FormattedMessage
              defaultMessage="Yes (We will send you an email with more information)"
              id="checkout.dicom.notify.yes"
            />
          </FormCheck>
          <br />
          <FormCheck
            type="radio"
            name="dicomNotify"
            invalid={meta.invalid}
            checked={value === false}
            onChange={() => onChange(false)}
          >
            <FormattedMessage
              defaultMessage="No"
              id="checkout.dicom.notify.no"
            />
          </FormCheck>
          <ValidationTooltip
            theme="danger"
            target={controlRef}
            show={meta.invalid}
            errors={meta.errors}
          />
        </Card.Body>
        <Card.Body>
          <a
            href={dicomRequirements}
            target="_blank"
            rel="noopener noreferrer"
          >
            <FormattedMessage
              id="dicom.reqs"
              defaultMessage="Butterfly Cloud DICOM Connector Requirements"
            />
          </a>
        </Card.Body>
      </Card>
    );
  }
}

DicomCard.propTypes = propTypes;

export default DicomCard;
